import { render, staticRenderFns } from "./ProductsConfig.vue?vue&type=template&id=099b96f2&scoped=true"
import script from "./ProductsConfig.vue?vue&type=script&lang=js"
export * from "./ProductsConfig.vue?vue&type=script&lang=js"
import style0 from "./ProductsConfig.vue?vue&type=style&index=0&id=099b96f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b96f2",
  null
  
)

export default component.exports